import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import Content from '../../components/Content/Content';
import Heading from '../../components/Heading/Heading';
import { getAlert } from '../../services/alertsService';
import Error from '../../components/Error/Error';

const parseSuggestions = suggestions =>
  suggestions.map(({ faqQuestion: label, slug: value, faqCategory }) => ({
    label,
    value: value.replace(
      'resources/faqs/',
      `resources/faqs/${slugByLabel(faqCategory?.[0])}/`
    ),
  }));

function AlertDetail({
  error,
  data: {
    contentfulPageName,
    bannerCallout,
    bannerText,
    bannerLinkText,
    pageLink,
    alertOptions,
    titleTag,
    metaDescription,
    publicationDate,
    alertContent1,
    alertPageTitle,
    modalHeader,
    modalContent,
    ...props
  } = {},
  isLoading,
  className,
}) {
  if (error) {
    console.error(error);
    return (
      <Layout>
        <Error />
      </Layout>
    );
  }

  return (
    <Layout isLoading={isLoading} className={className}>
      <SEO title={titleTag} description={metaDescription} />

      <Heading>
        <ReactMarkdown
          source={alertPageTitle}
          renderers={{
            text: ({ children }) => <h1>{children}</h1>,
          }}
        ></ReactMarkdown>
      </Heading>

      <Content divider={false}>
        <ReactMarkdown source={alertContent1} />
      </Content>
    </Layout>
  );
}

AlertDetail.getInitialProps = async ({ match, req }) => {
  try {
    // Fetch server-rendered data here
    const { alertId } = match.params;

    const alertDetail = await getAlert(`/alerts/${alertId}/`);

    if (alertDetail.status !== 200 && alertDetail.status !== 204) {
      throw alertDetail.statusText;
    }

    return {
      data: alertDetail.data.result,
    };
  } catch (error) {
    // Handle issues loading data
    if (error.response.status === 404) return { statusCode: 404 };
    return { error };
  }
};

AlertDetail.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default AlertDetail;
